//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ShareLinks',
  props: {
    pageTitle: {
      type: String,
      required: true,
      default: () => ''
    },
    pageDescription: {
      type: String,
      required: true,
      default: () => ''
    },
    pageImg: {
      type: String,
      required: true,
      default: () => ''
    },
  },
  computed: {
    pageUrl() {
      return encodeURIComponent(document.URL)
    },
    shareLinks() {
      return [
        { label: 'VK', color: '#4169e1', url: `http://vk.com/share.php?url=${this.pageUrl}&title=${this.pageTitle}&description=${this.pageDescription}&image=${this.pageImg}`, icon: 'vk', width: 570, height: 450 },
        { label: 'Telegram', color: '#29a9eb', url: `https://telegram.me/share/url?url=${this.pageUrl}&text=${this.pageTitle}`, icon: 'telegram', width: 570, height: 450 },
        { label: 'WhatsApp', color: '#1b8755', url: `https://wa.me/?text=${this.pageTitle}%20${this.pageDescription}%20${this.pageUrl}`, icon: 'whatsapp', width: 570, height: 450 },
        { label: 'Одноклассники', color: '#ff7700', url: `https://connect.ok.ru/offer?url=${this.pageUrl}&title=${this.pageTitle}&description=${this.pageDescription}&imageUrl=${this.pageImg}`, icon: 'ok', width: 570, height: 450 },
      ]
    }
  },
  methods: {
    async copyLink() {
      await navigator.clipboard.writeText(document.URL)
        .then(() => this.$message.success('Ссылка скопирована'))
    },
    socialWindow(url, width, height) {
      const top = (screen.height - height) / 2;
      const left = (screen.width - width) / 2;
      const params = "menubar=no,toolbar=no,status=no,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left;
      window.open(url,"",params);
    }
  }
}
